// extracted by mini-css-extract-plugin
module.exports = {"container":"coupon-content_container__1LGTd","coupon-list":"coupon-content_coupon-list__3o_ch"};